import React from 'react'
import AdmStudentPromotion from '../../components/AdminTabs/AdminStudentPromotion/AdmStudentPromotion'

const StudentPromotion = () => {
  return (
    <div>
      <AdmStudentPromotion />
    </div>
  )
}

export default StudentPromotion
